export enum PostregOptions {
  VERIFY_FUNDING = 'VERIFY_FUNDING',
  COMPLETE = 'COMPLETE'
}

export type Step = {
  component: JSX.Element;
  roles: Array<'parent' | 'child' | 'approver'>;
  shouldShow: () => boolean;
};
